import { emojiChecker } from 'src/logic'
import { Embroidery } from 'src/types'

const fontFamilySetter = (ctx: CanvasRenderingContext2D, selectedFontValue: string): void => {
  const fontSize = selectedFontValue === 'Brush Script MT' ? '44px' : '32px'
  // 非同期でフォントを反映させるための関数
  const fontLoader = () => {
    const oldEnglishFont = new FontFace(selectedFontValue, `url(/fontFamily/embroidery/${selectedFontValue}.ttf)`)
    oldEnglishFont.load().then((font) => {
      document.fonts.add(font) // DOMにfont情報を読み込ませるの必須
      ctx.font = `${fontSize} ${font.family}`
    })
  }
  switch (selectedFontValue) {
    case 'MariageD': {
      // オールドイングリッシュ
      fontLoader()
      break
    }
    case 'CloisterBlack': {
      // Yell story 特殊文字
      fontLoader()
      break
    }
    case 'Brush Script MT':
      ctx.font = `${fontSize} ${selectedFontValue}`
      break

    default:
      break
  }
}

export const liningEmbroidery = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number, fontSizeValue?: string): void => {
  fontFamilySetter(ctx, embroidery.typeFace.value)
  // 以下の font 再宣言必須
  const typeFace = embroidery.typeFace.value
  const fontSize = fontSizeValue || typeFace === 'Brush Script MT' ? '39px' : typeFace === 'Zapfino, cursive' ? '18px' : '28px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.textAlign = 'center'
  ctx.lineWidth = 0.8
  ctx.fillStyle = embroidery.color.color // '#383838'
  // 手入れ口部分
  ctx.beginPath()
  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 3.0
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  ctx.strokeText(embroidery.content, 280 + x, 500 + y)
  ctx.fillText(embroidery.content, 280 + x, 500 + y)
  ctx.closePath()
  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#282828'
  }
  ctx.textAlign = 'start'
}

export const liningEmbroideryWithEmoji = (
  ctx: CanvasRenderingContext2D,
  embroidery: Embroidery,
  x: number,
  y: number,
  fontSizeValue?: string
): void => {
  fontFamilySetter(ctx, embroidery.typeFace.value)
  // 以下の font 再宣言必須
  const fontSize = fontSizeValue || embroidery.typeFace.value === 'Brush Script MT' ? '44px' : '32px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.textAlign = 'center'
  ctx.lineWidth = 0.8
  ctx.fillStyle = embroidery.color.color // '#383838'
  // // 手入れ口部分

  // 絵文字の存在をチェックし、絵文字があれば影・フチの色はつけない
  ctx.beginPath()
  const contents = embroidery.content
  let x2 = x
  for (let i = 0; i < contents.length; i++) {
    let char = contents[i]
    if (char === '\uD83E') {
      continue
    } // ハートが文字化けして文字コードx2が発生するので1つスキップ
    if (char === '\uDE77') {
      char.replace('\uDE77', '🩷')
    }
    const isEmoji = emojiChecker(char) || char === '\uDE77'
    if (isEmoji) {
      ctx.shadowColor = 'transparent'
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 0
      ctx.shadowBlur = 0
    } else {
      // 影カラー
      if (embroidery?.shadowColor?.value !== 'none') {
        ctx.shadowColor = embroidery?.shadowColor?.color
        ctx.shadowOffsetX = 3
        ctx.shadowOffsetY = 3
        ctx.shadowBlur = 3
      }
      // フチカラー
      if (embroidery?.edgeColor?.value !== 'none') {
        ctx.lineWidth = 1.5
        ctx.strokeStyle = embroidery.edgeColor.color
      }
    }
    const text = char === '\uDE77' ? '🩷' : char
    ctx.strokeText(text, 240 + x2, 500 + y)
    ctx.fillText(text, 240 + x2, 500 + y)
    x2 += ctx.measureText(char).width - 2
  }
  ctx.closePath()

  // 影カラーリセット
  if (embroidery?.shadowColor?.value !== 'none') {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (embroidery?.edgeColor?.value !== 'none') {
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#282828'
  }
  ctx.textAlign = 'start'
}

export const bottomRightOfBeltEmbroidery = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number): void => {
  fontFamilySetter(ctx, embroidery.typeFace.value)
  const typeFace = embroidery.typeFace.value
  const fontSize = typeFace === 'Brush Script MT' ? '30px' : typeFace === 'Zapfino, cursive' ? '14px' : '22px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.lineWidth = 1.0
  ctx.fillStyle = embroidery.color.color // '#383838'
  // 手入れ口部分
  ctx.beginPath()
  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 3.0
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  ctx.strokeText(embroidery.content, 470 + x, 575 + y)
  ctx.fillText(embroidery.content, 470 + x, 575 + y)
  ctx.closePath()
  // 影カラーリセット
  if (embroidery?.shadowColor?.value !== 'none') {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (embroidery?.edgeColor?.value !== 'none') {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
}

export const sideOfLabelEmbroidery = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number): void => {
  fontFamilySetter(ctx, embroidery.typeFace.value)
  const typeFace = embroidery.typeFace.value
  const fontSize = typeFace === 'Brush Script MT' ? '30px' : typeFace === 'Zapfino, cursive' ? '14px' : '22px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.lineWidth = 1.0
  ctx.fillStyle = embroidery.color.color // '#383838'
  // 手入れ口部分
  ctx.beginPath()
  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 3.0
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  ctx.strokeText(embroidery.content, 325 + x, 550 + y)
  ctx.fillText(embroidery.content, 325 + x, 550 + y)
  ctx.closePath()
  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
}

export const thumbEmbroidery = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number, numerator?: number): void => {
  ctx.lineWidth = 1.0
  ctx.fillStyle = embroidery.color.color // '#383838'
  ctx.textAlign = 'start'
  ctx.save()
  ctx.rotate(((-35 + (numerator || 0)) * Math.PI) / 180)
  ctx.beginPath()
  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 2.5
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  fontFamilySetter(ctx, embroidery.typeFace.value)
  const typeFace = embroidery.typeFace.value
  const fontSize = typeFace === 'Brush Script MT' ? '30px' : typeFace === 'Zapfino, cursive' ? '14px' : '22px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.strokeText(embroidery.content, 110 + x, 714 + y)
  ctx.fillText(embroidery.content, 110 + x, 714 + y)
  ctx.closePath()
  // 影カラーリセット
  if (embroidery?.shadowColor?.value !== 'none') {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
  ctx.restore()
}

export const thumbEmbroideryUs = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number, numerator?: number): void => {
  ctx.lineWidth = 0.8
  ctx.fillStyle = embroidery.color.color // '#383838'
  ctx.textAlign = 'start'
  ctx.save()
  ctx.rotate(((-35 + (numerator || 0)) * Math.PI) / 180)
  ctx.beginPath()
  fontFamilySetter(ctx, embroidery.typeFace.value)
  // 以下の font 再宣言必須
  const fontSize = embroidery.typeFace.value === 'Brush Script MT' ? '30px' : '25px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  const contents = embroidery.content
  let x2 = x
  for (let i = 0; i < contents.length; i++) {
    let char = contents[i]
    if (char === '\uD83E') {
      continue
    } // ハートが文字化けして文字コードx2が発生するので1つスキップ
    if (char === '\uDE77') {
      char.replace('\uDE77', '🩷')
    }
    const isEmoji = emojiChecker(char) || char === '\uDE77'
    if (isEmoji) {
      ctx.shadowColor = 'transparent'
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 0
      ctx.shadowBlur = 0
    } else {
      // 影カラー
      if (embroidery?.shadowColor?.value !== 'none') {
        ctx.shadowColor = embroidery?.shadowColor?.color
        ctx.shadowOffsetX = 3
        ctx.shadowOffsetY = 3
        ctx.shadowBlur = 3
      }
      // フチカラー
      if (embroidery?.edgeColor?.value !== 'none') {
        ctx.lineWidth = 2.5
        ctx.strokeStyle = embroidery.edgeColor.color
      }
    }
    const text = char === '\uDE77' ? '🩷' : char
    ctx.strokeText(text, 110 + x2, 715 + y)
    ctx.fillText(text, 110 + x2, 715 + y)
    x2 += ctx.measureText(char).width
  }
  ctx.closePath()
  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
  ctx.restore()
}

export const thumbEmbroideryLeftThrow = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number, numerator?: number): void => {
  ctx.lineWidth = 1.0
  ctx.fillStyle = embroidery.color.color // '#383838'
  ctx.strokeStyle = embroidery.color.color
  ctx.textAlign = 'start'
  ctx.save()
  ctx.rotate(((50 + (numerator || 0)) * Math.PI) / 180)
  ctx.beginPath()
  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 2.5
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  fontFamilySetter(ctx, embroidery.typeFace.value)
  // 以下の font 再宣言必須
  const typeFace = embroidery.typeFace.value
  const fontSize = typeFace === 'Brush Script MT' ? '30px' : typeFace === 'Zapfino, cursive' ? '14px' : '22px'
  const textCount = embroidery.content.length
  const width = textCount > 7 ? 380 : textCount > 4 ? 480 : 500
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.strokeText(embroidery.content, width + x, 70 + y)
  ctx.fillText(embroidery.content, width + x, 70 + y)
  ctx.closePath()
  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
  ctx.restore()
}

export const notThumbEmbroidery = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number, numerator?: number): void => {
  const typeFace = embroidery.typeFace.value
  const fontSize = typeFace === 'Brush Script MT' ? '30px' : typeFace === 'Zapfino, cursive' ? '14px' : '22px'
  ctx.lineWidth = 1.0
  fontFamilySetter(ctx, embroidery.typeFace.value)
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.textAlign = 'start'
  ctx.fillStyle = embroidery.color.color // '#383838'
  // 手入れ口部分
  ctx.save()
  ctx.rotate(((90 + (numerator || 0)) * Math.PI) / 180)
  ctx.beginPath()

  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 2.5
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  ctx.strokeText(embroidery.content, 265 + x, -160 + y)
  ctx.fillText(embroidery.content, 265 + x, -160 + y)
  ctx.closePath()
  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
  ctx.restore()
}

export const firstMittChildFingerEmbroidery = (ctx: CanvasRenderingContext2D, embroidery: Embroidery, x: number, y: number): void => {
  fontFamilySetter(ctx, embroidery.typeFace.value)
  const typeFace = embroidery.typeFace.value
  const fontSize = typeFace === 'Brush Script MT' ? '30px' : typeFace === 'Zapfino, cursive' ? '14px' : '20px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.textAlign = 'start'
  ctx.lineWidth = 1.0
  ctx.fillStyle = embroidery.color.color // '#383838'
  // 手入れ口部分
  ctx.save()
  ctx.rotate((-10 * Math.PI) / 180)
  ctx.beginPath()

  // 影カラー
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowColor = embroidery?.shadowColor?.color
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 3
  }
  // フチカラー
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 2.5
    ctx.strokeStyle = embroidery.edgeColor.color
  }
  ctx.strokeText(embroidery.content, 265 + x, -160 + y)
  ctx.fillText(embroidery.content, 265 + x, -160 + y)
  ctx.closePath()
  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#282828'
  }
  ctx.restore()
}

export const notThumbEmbroideryWithEmoji = (
  ctx: CanvasRenderingContext2D,
  embroidery: Embroidery,
  x: number,
  y: number,
  numerator?: number
): void => {
  fontFamilySetter(ctx, embroidery.typeFace.value)
  // 以下の font 再宣言必須
  const fontSize = embroidery.typeFace.value === 'Brush Script MT' ? '32px' : '32px'
  ctx.font = `${fontSize} ${embroidery.typeFace.value}`
  ctx.textAlign = 'start'
  ctx.lineWidth = 1.0
  ctx.fillStyle = embroidery.color.color // '#383838'
  // 手入れ口部分
  ctx.save()
  ctx.rotate(((90 + (numerator || 0)) * Math.PI) / 180)

  // 絵文字の存在をチェックし、絵文字があれば影・フチの色はつけない
  ctx.beginPath()
  const contents = embroidery.content
  let x2 = x
  for (let i = 0; i < contents.length; i++) {
    let char = contents[i]
    if (char === '\uD83E') {
      continue
    } // ハートが文字化けして文字コードx2が発生するので1つスキップ
    if (char === '\uDE77') {
      char.replace('\uDE77', '🩷')
    }
    const isEmoji = emojiChecker(char) || char === '\uDE77'
    if (isEmoji) {
      ctx.shadowColor = 'transparent'
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 0
      ctx.shadowBlur = 0
    } else {
      // 影カラー
      if (embroidery?.shadowColor?.value !== 'none') {
        ctx.shadowColor = embroidery?.shadowColor?.color
        ctx.shadowOffsetX = 3
        ctx.shadowOffsetY = 3
        ctx.shadowBlur = 3
      }
      // フチカラー
      if (embroidery?.edgeColor?.value !== 'none') {
        ctx.lineWidth = 2.5
        ctx.strokeStyle = embroidery.edgeColor.color
      }
    }
    const text = char === '\uDE77' ? '🩷' : char
    ctx.strokeText(text, 265 + x2, -160 + y)
    ctx.fillText(text, 265 + x2, -160 + y)
    x2 += ctx.measureText(char).width
  }
  ctx.closePath()

  // 影カラーリセット
  if (!['unselected', 'none'].includes(embroidery?.shadowColor?.value)) {
    ctx.shadowOffsetX = 0
    ctx.shadowOffsetY = 0
    ctx.shadowBlur = 0
  }
  // フチカラーリセット
  if (!['unselected', 'none'].includes(embroidery?.edgeColor?.value)) {
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#282828'
  }
  ctx.restore()
}
